{
  "quiz": {
    "takeQuiz": "Take quiz",
    "generating": "Generating quiz...",
    "generationFailed": "The quiz could not be generated. Try again.",
    "ready": "Your quiz is ready.",
    "progress": "{{current}} of {{total}}",
    "incorrect": "Not quite. Try another option.",
    "reasonHeading": "Correct",
    "next": "Next",
    "doneTitle": "Quiz completed",
    "doneDescription": "You answered every question correctly.",
    "takeAgain": "Take again"
  }
}
